import React from "react";
import PostDistanceModalContent from "./PostDistanceModalContent";
const PostDistanceModal = (props) => {
    return (React.createElement("div", { className: 'modal fade', id: 'modal-activity-post', tabIndex: -1, role: 'dialog', "aria-labelledby": 'modal-activity-post', "aria-hidden": 'true', "data-bs-backdrop": 'static', "data-bs-keyboard": 'false' },
        React.createElement("div", { className: 'modal-dialog modal-dialog-centered modal-dialog-scrollable' },
            React.createElement(PostDistanceModalContent, { ...props }))));
};
export default PostDistanceModal;
